import { GetTeamSubscriptionMetricsAppsSummaryTotalWholeTeamQuery } from '../../../../../src/interface/queries/team-metrics/subscription/get-team-subscription-metrics-apps-summary-total-whole-team.query';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { TeamSubscriptionMetricsAppsSummaryTotalWholeTeamAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/subscription/team-subscription-metrics-app-summary-total-whole-team.aggregate-root.mapper';
import { GetTeamSubscriptionMetricsAppsSummaryResponseDto } from '../../../../../src/interface/dtos/team-metrics/subscription/get-team-subscription-metrics-apps-summary.response.dto';
import { GetTeamSubscriptionMetricsAppsSummaryTotalWholeTeamRequestDto } from '../../../../../src/interface/dtos/team-metrics/subscription/get-team-subscription-metrics-apps-summary-total-whole-team.request.dto';

export class GetTeamSubscriptionMetricsAppsSummaryTotalWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetTeamSubscriptionMetricsAppsSummaryTotalWholeTeamQuery,
    protected readonly mapper: TeamSubscriptionMetricsAppsSummaryTotalWholeTeamAggregateRootMapper
  ) {}

  async get(
    props: GetTeamSubscriptionMetricsAppsSummaryTotalWholeTeamRequestDto
  ): Promise<GetTeamSubscriptionMetricsAppsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `TeamSubscriptionMetricsAppsSummaryTotalWholeTeamComponentController.get encountered an error ${error}`
      );
    }
  }
}
